import React, { useEffect, useMemo, useRef, useState } from 'react';
import trash from '../../../../../assets/restaurant/images/trash.svg';
import { getCategories, addCategory, deleteCategory, editCategory, sortCategories, categoryDetail } from '../../../services/category.services';
import { LOADER_TIMEOUT_TIME, SWAL_SETTINGS } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter, capitalizeFirstLetterOfEachWord, getColorType, getTranslatedKey, globalLoader, handleOffcanvasScroll, handleServerValidations, removeSpecialCharacter, useDebouncing, TrimText } from '../../../../../utils/commonfunction';
import { CATEGORIES_TAX_TYPES } from '../../../../../utils/Constants';
import { ReactSortable } from 'react-sortablejs';
import CustomError from "../../../../../utils/customError";
import { Link } from 'react-router-dom';
import GridLoader from '../../../shared/gridLoader';
import RecordNotFound from '../../../shared/recordNotFound';
import { taxSettingOptions } from '../../../services/tax.services';
import { getRestaurantSettings } from '../../../services/profile.services';

export default function CategoriesListing() {
    const [sortableCategories, setSortableCategories] = useState([]);
    const [search, setSearch] = useState({})
    const [refreshList, setRefreshList] = useState(false);
    const [List, setList] = useState([]);
    const addCategoryCloseBtn = useRef();
    const editCategoryCloseBtn = useRef();
    const sortingCloseBtn = useRef();
    const [loader, setLoader] = useState(true);
    const { t } = useTranslation();
    const { categoryValidationSchema } = useValidationSchemas();
    const [globalSearch, setGlobalSearch] = useState('');
    const [langChanged, setLangChanged] = useState(false);
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
    const [taxOptions, setTaxOptions] = useState([]);
    const [settingsData, setSettingsData] = useState({})

    const addForm = useFormik({
        initialValues: {
            image: "",
            name: "",
            tax_type: "",
            short_description: "",
        },
        validationSchema: categoryValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            setAddSubmissionLoader(true);
            const formData = new FormData();
            const imageValue = document.getElementById('addImage').files[0];
            formData.append("image", imageValue);
            formData.append("name", values.name);
            formData.append("tax_type", values.tax_type);
            formData.append("short_description", values.short_description);
            console.log(values)
            addCategory(formData)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        addCategoryCloseBtn?.current?.click();
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                    setAddSubmissionLoader(false);
                })
                .catch((error) => {
                    console.error("Error updating profile", error);
                    setAddSubmissionLoader(false);
                });
            console.log(values);
        },
    });

    const editForm = useFormik({
        initialValues: {
            _id: "",
            image: "",
            name: "",
            tax_type: "",
            short_description: "",
        },
        validationSchema: categoryValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            setEditSubmissionLoader(true);
            const formData = new FormData();
            formData.append("o_id", values?._id);
            formData.append("image", values?.image);
            formData.append("name", values?.name);
            formData.append("tax_type", values?.tax_type);
            formData.append("short_description", values?.short_description);
            editCategory(formData)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setRefreshList(!refreshList);
                        editCategoryCloseBtn?.current?.click();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                    setEditSubmissionLoader(false);
                })
                .catch((error) => {
                    console.error("Error updating profile", error);
                    setEditSubmissionLoader(false);
                });
        },
    });

    const deleteCategories = (item) => {
        Swal.fire({
            title: t("restaurant.menu.delete_msg_are_you_sure"),
            text: t("restaurant.menu.btn_delete_text"),
            imageUrl: trash,
            showCancelButton: true,
            confirmButtonColor: "var(--primary)",
            cancelButtonColor: "#6c757d",
            confirmButtonText: t("restaurant.button.btn_delete"),
            cancelButtonText: t("restaurant.button.btn_cancel"),
            reverseButtons: true,
            customClass: {
                popup: 'swal-restaurant',
                confirmButton: 'btn btn-danger col',
                cancelButton: 'btn btn-secondary col'
            },
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                globalLoader(true);
                deleteCategory({ o_id: item._id }).then((response) => {
                    globalLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                }).catch((error) => {
                    globalLoader(false);
                    console.log("deleteError");
                });
            } else {
                setSortableCategories(List);
            }
        });

    };

    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));

        }
        formData.append("global_search", globalSearch);
        getCategories(formData).then(data => {
            setList(data && data.data && data.data.list ? data.data.list : []);
            setSortableCategories(data && data.data && data.data.list ? data.data.list : []);
            setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
        }).catch(error => {
            setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
            console.log("error ====> ", error);
        });
    }, [search, refreshList, globalSearch, langChanged]);

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const prepareGlobalSearch = (value) => {
        setGlobalSearch(value);
    };
    const searchDebounce = useDebouncing(prepareGlobalSearch);

    const getCategoryDetail = (item) => {
        categoryDetail({ o_id: item._id }).then((response) => {
            if (response.success) {
                editForm.setValues({
                    _id: item._id,
                    image: response?.data?.image || "",
                    name: response?.data?.name || "",
                    tax_type: response?.data?.tax_type || "",
                    short_description: response?.data?.short_description || "",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                });
            }
        }).catch((err) => {
            console.log(err)
        });
    };

    function handleSortCategories(closeModal = true) {
        sortCategories({ sorted_array: sortableCategories }).then((response) => {
            if (response.success) {
                Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                });
                if (closeModal) {
                    sortingCloseBtn?.current?.click();
                }
                setRefreshList(!refreshList);
            } else {
                Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                });
            }
        }).catch((error) => {
            console.error("Error updating profile", error);
        });
    }
    function isSortingChanged() {
        let changed = false;
        let i = 0;
        for (i; i < List.length; i++) {
            if (List[i]?.order !== sortableCategories[i]?.order) {
                changed = true;
                break;
            } else {
                changed = false;
            }
        };
        return changed;
    }
    const handleCloseSorting = () => {
        if (isSortingChanged()) {
            Swal.fire({
                title: t("question_to_save_data"),
                text: t("confirm_heading_found_unsaved_data_description"),
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#6c757d",
                cancelButtonColor: "#dc3545",
                confirmButtonText: t("btn_text_save_changes"),
                cancelButtonText: t("btn_text_discard"),
                customClass: {
                    popup: 'swal-restaurant',
                    confirmButton: 'btn btn-secondary col',
                    cancelButton: 'btn btn-danger col'
                },
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    handleSortCategories(false);
                } else {
                    setSortableCategories(List);
                }
            });
        }
    };

   

    useEffect(() => {
        getRestaurantSettings()
            .then((response) => {
                setTimeout(() => {
                }, LOADER_TIMEOUT_TIME);
                setSettingsData(response && response?.data ? response?.data : {});
            })
            .catch((error) => {
                setTimeout(() => {
                }, LOADER_TIMEOUT_TIME);
                console.log("Error===>", error);
            });
    }, []);


    return (
        <main id='main-content'>
            <div className='inner-container'>
                <div className='page-header d-flex align-items-center'>
                    <h4 className='heading-title-text'>{t("restaurant.menu.heading_categories")}</h4>
                </div>
                <div className='card-outer-header d-flex justify-content-between align-items-center mb-4'>
                    <div className='search-box'>
                        <input type='text' className='form-control search-input' placeholder={t("restaurant.menu.input_placeholder_search")} onInput={(e) => {
                            searchDebounce(e.target.value);
                        }} />
                    </div>
                    <div className='card-head-group d-flex align-items-center gap-2'>
                        <div className="tabls-dowpdown">
                            <select className="form-control cp" onChange={(e) => { prepareSearch('tax_type', e.target.value) }}>
                                <option value="">{t("restaurant.menu.label_type")}</option>
                                <option value='free' label="Free" />
                                {['certain_baby_food_item_Vat', 'general_Vat'].map((key) => (
                                    <option key={key} value={key}>
                                        {removeSpecialCharacter(capitalizeFirstLetterOfEachWord(key))}({settingsData[key]}%)
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#sort-modal">{t("label_sort_category")}</button> */}
                        <button className='btn btn-primary' data-bs-toggle="offcanvas" data-bs-target="#add-new-category"> {t("restaurant.menu.label_create_category")}</button>
                    </div>
                </div>
                <div className='dashboard-content-wraper'>
                    <div className='category-list-wrap'>
                        {
                            loader ?
                                <GridLoader innerClass='bg-base-color' />
                                :
                                List.length ?
                                    <div className='category-list-grid'>
                                        {List.map((item, index) => {
                                            return (<div key={index} className={'category-box d-flex align-items-center justify-content-between ' + (`category_bg`)} style={{ background: item.color }}>
                                                <div className='category-item-info d-flex flex-column text-start mt-0'>
                                                    <h3 className='text-black'>{TrimText(capitalizeFirstLetter(item?.name), 18)} </h3>
                                                    <Link className='text-black' to={`/restaurant/menu/menu-item/list/${item?._id}`}>{item?.items_count} {t("restaurant.menu.label_menu_item")}</Link>
                                                </div>
                                                <div className='dropdown '>
                                                    <button className="btn-icon" type="button" data-bs-toggle="dropdown" aria-expanded="true"><i className='ti ti-dots-vertical'></i></button>
                                                    <ul className='dropdown-menu'>
                                                        <li>
                                                            <button className='dropdown-item' onClick={() => { getCategoryDetail(item); }} data-bs-toggle="offcanvas" data-bs-target="#view-new-category"><i className='ti ti-eye'></i> View</button>
                                                        </li>
                                                        <li>
                                                            <button onClick={() => { getCategoryDetail(item); }} data-bs-toggle="offcanvas" data-bs-target="#edit-new-category" className='dropdown-item'><i className='ti ti-edit'></i> Edit</button>
                                                        </li>
                                                        <li>
                                                            <button onClick={() => { deleteCategories(item) }} className='dropdown-item'><i className='ti ti-trash'></i> Delete</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>)
                                        })}
                                    </div>
                                    :
                                    <RecordNotFound heading="restaurant.menu.no_category_found_text" />
                        }
                    </div>
                </div>
            </div>
            {/* modal for edit a category  */}

            <div className="offcanvas offcanvas-end right-modal-w" id="edit-new-category" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">{t("restaurant.menu.label_edit_category")}</h3>
                    <button type="button" className="btn btn-icon ms-auto" ref={editCategoryCloseBtn} data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => { editForm.resetForm() }}>
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body" onScroll={(e) => {
                    handleOffcanvasScroll(e, "edit-new-category");
                }}>
                    <form onSubmit={editForm.handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">{t("Add Photo")}
                            </label>
                            <input
                                className="form-control imgInput"
                                id="editImage"
                                name="image"
                                accept="image/*"
                                type="file"
                                // value={addItemForm?.values?.image}
                                onChange={(event) => {
                                    const file = event.currentTarget.files[0];
                                    editForm.setFieldTouched("image", true, false);
                                    console.log('edit file', file)
                                    if (file) {
                                        const validTypes = [
                                            "image/jpeg",
                                            "image/png",
                                            "image/jpg",
                                            "image/gif",
                                            "image/webp",
                                        ];
                                        const maxSize = 1.5 * 1024 * 1024;

                                        if (!validTypes.includes(file.type)) {
                                            editForm.setFieldError("image", "Please upload a valid image format (jpg, jpeg, png, gif, webp).");
                                            document.getElementById('editImage').value = ""; // Clear the invalid file input using
                                        } else if (file.size > maxSize) {
                                            editForm.setFieldError("image", "Image size must be less than 1.5 MB.");
                                            document.getElementById('editImage').value = ""; // Clear the invalid file input using
                                        } else {
                                            editForm.setFieldValue("image", file);
                                        }
                                    } else {
                                        editForm.setFieldValue("image", null);
                                    }
                                }}
                            />

                            {/* ✅ Always show errors when touched or invalid */}
                            {editForm.errors.image && (
                                <div className="text-danger mt-1">{editForm.errors.image}</div>
                            )}
                            {/* <CustomError name="image" form={editForm} className="text-danger" /> */}
                            <span className="mt-2 d-block">{t("Only JPEF, PNG files with max size 1.5 MB , Resolution supported 300X200")}</span>
                            {editForm.values.image && (
                                <ul className="question-image-preview questions-ul">
                                    <li className="pr_img_box">
                                        <img src={editForm.values.image instanceof File ? URL.createObjectURL(editForm.values.image) : editForm.values.image} style={{ height: "100px" }} alt={"Profile_Img"} />
                                        <button
                                            type="button"
                                            className="btn-icon"
                                            style={{ position: "absolute", right: "5px", top: "5px", height: "30px", width: "30px", minWidth: "30px" }}
                                            onClick={() => {
                                                editForm.setFieldValue("image", null);
                                                document.getElementById("editImage").value = "";
                                            }}
                                        >
                                            <i className="ti ti-x"></i>
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </div>
                        <div className="mb-3">
                            <input type="hidden" name="_id" value={editForm.values._id} onChange={editForm.handleChange} />
                            <label className="form-label">{t("restaurant.menu.label_category_name")} <span>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("restaurant.menu.category_name_placeholder")}
                                name="name"
                                value={editForm.values.name}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            {editForm.touched.name && editForm.errors.name ? (
                                <div className="text-danger">{t(editForm.errors.name)}</div>
                            ) : null}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("restaurant.menu.label_type_tax")}<span>*</span></label>
                            <select
                                className="form-control cp"
                                name="tax_type"
                                value={editForm.values.tax_type}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            >
                                <option value="" label={t("restaurant.menu.select_option_type_tax")} />
                                {/* {CATEGORIES_TAX_TYPES.map((item, index) => { return (<option key={index} value={item.value}>{t(item.label)}</option>) })} */}
                                <option value='free' label="Free" />
                                {['certain_baby_food_item_Vat', 'general_vat'].map((key) => (
                                    <option key={key} value={key}>
                                        {removeSpecialCharacter(capitalizeFirstLetterOfEachWord(key))}({settingsData[key]}%)
                                    </option>
                                ))}
                            </select>
                            {editForm.touched.tax_type && editForm.errors.tax_type ? (
                                <div className="text-danger">{t(editForm.errors.tax_type)}</div>
                            ) : null}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("restaurant.menu.label_short_description")}<span>*</span></label>
                            <textarea
                                className="form-control"
                                style={{ height: "120px" }}
                                name="short_description"
                                value={editForm.values.short_description}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                                placeholder={t("restaurant.menu.placeholder_description")}
                            />
                            {editForm.touched.short_description && editForm.errors.short_description ? (
                                <div className="text-danger">{t(editForm.errors.short_description)}</div>
                            ) : null}
                        </div>
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                                {t("restaurant.menu.btn_update")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* modal for add a category  */}

            <div className="offcanvas offcanvas-end right-modal-w" id="add-new-category" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">{t("restaurant.menu.label_create_category")}</h3>
                    <button type="button" className="btn btn-icon ms-auto" ref={addCategoryCloseBtn} data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => { addForm.resetForm() }}>
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body" onScroll={(e) => {
                    handleOffcanvasScroll(e, "add-new-category");
                }}>
                    <form onSubmit={addForm.handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">{t("Add Photo")}</label>

                            <input
                                className="form-control imgInput"
                                id="addImage"
                                name="image"
                                accept="image/jpeg,image/png,image/jpg,image/gif,image/webp"
                                type="file"
                                onChange={(event) => {
                                    const file = event.currentTarget.files[0];
                                    addForm.setFieldTouched("image", true, false);

                                    if (file) {
                                        const validTypes = [
                                            "image/jpeg",
                                            "image/png",
                                            "image/jpg",
                                            "image/gif",
                                            "image/webp",
                                        ];
                                        const maxSize = 1.5 * 1024 * 1024;

                                        if (!validTypes.includes(file.type)) {
                                            addForm.setFieldError("image", "Please upload a valid image format (jpg, jpeg, png, gif, webp).");
                                            document.getElementById('addImage').value = ""; // Clear the invalid file input using
                                        } else if (file.size > maxSize) {
                                            addForm.setFieldError("image", "Image size must be less than 1.5 MB.");
                                            document.getElementById('addImage').value = ""; // Clear the invalid file input using
                                        } else {
                                            addForm.setFieldValue("image", file);
                                        }
                                    } else {
                                        addForm.setFieldValue("image", null);
                                    }
                                }}
                            />

                            {/* ✅ Always show errors when touched or invalid */}
                            {addForm.errors.image && (
                                <div className="text-danger mt-1">{addForm.errors.image}</div>
                            )}

                            <span className="mt-2 d-block text-muted">
                                Only JPEG, PNG, GIF, WEBP files with max size 1.5 MB, recommended resolution
                                300×200
                            </span>

                            {addForm.values.image && (
                                <ul className="question-image-preview questions-ul mt-2">
                                    <li className="pr_img_box" style={{ position: "relative" }}>
                                        <img
                                            src={URL.createObjectURL(addForm.values.image)}
                                            style={{ height: "100px" }}
                                            alt="Uploaded Preview"
                                        />
                                        <button
                                            type="button"
                                            className="btn-icon"
                                            style={{
                                                position: "absolute",
                                                right: "5px",
                                                top: "5px",
                                                height: "30px",
                                                width: "30px",
                                                minWidth: "30px",
                                            }}
                                            onClick={() => {
                                                addForm.setFieldValue("image", null);
                                                document.getElementById("image").value = "";  // Clear file input
                                            }}
                                        >
                                            <i className="ti ti-x"></i>
                                        </button>
                                    </li>
                                </ul>
                            )}

                        </div>



                        <div className="mb-3">
                            <label className="form-label">{t("restaurant.menu.label_category_name")}<span>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("restaurant.menu.category_name_placeholder")}
                                name="name"
                                value={addForm.values.name}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            {addForm.touched.name && addForm.errors.name ? (
                                <div className="text-danger">{t(addForm.errors.name)}</div>
                            ) : null}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("restaurant.menu.label_type_tax")}<span>*</span></label>
                            <select
                                className="form-control cp"
                                name="tax_type"
                                value={addForm.values.tax_type}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            >
                                <option value="" label={t("restaurant.menu.select_option_type_tax")} />
                                {/* {CATEGORIES_TAX_TYPES.map((item, index) => { return (<option key={index} value={item.value}>{t(item.label)}</option>) })} */}
                                <option value="free" label="Free" />
                                {['certain_baby_food_item_Vat', 'general_Vat'].map((key) => (
                                    <option key={key} value={key}>
                                        {removeSpecialCharacter(capitalizeFirstLetterOfEachWord(key))}({settingsData[key]}%)
                                    </option>
                                ))}
                            </select>
                            <CustomError name="tax_type" className='text-danger' form={addForm} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("restaurant.menu.label_short_description")}<span>*</span></label>
                            <textarea
                                className="form-control"
                                style={{ height: "120px" }}
                                name="short_description"
                                value={addForm.values.short_description}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                                placeholder={t("restaurant.menu.placeholder_description")}
                            />
                            {addForm.touched.short_description && addForm.errors.short_description ? (
                                <div className="text-danger">{t(addForm.errors.short_description)}</div>
                            ) : null}
                        </div>
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                                {t("restaurant.menu.btn_submit")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
           


            {/* modal for view  */}

            <div className="offcanvas offcanvas-end right-modal-w" id="view-new-category" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">{t("restaurant.menu.view_category_label")}</h3>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close" >
                        <i className="ti ti-x"></i>
                    </button>
                </div>

                <div className="offcanvas-body" onScroll={(e) => {
                    handleOffcanvasScroll(e, "view-new-category");
                }}>
                    <div className="view-info">
                        <div className="row gap-4">
                            <div className="col-md-12">
                                <h4>{t("restaurant.menu.label_category_name")}:</h4>
                                <p>{editForm.values.name}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("restaurant.menu.label_type_tax")}:</h4>
                                <p className='text-capitalize'>{removeSpecialCharacter(editForm.values.tax_type)}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("restaurant.menu.label_short_description")}:</h4>
                                <p>{editForm.values.short_description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
